<div class="content">
  <div
    class="content-body content-body-scroll"
    [ngClass]="[showPaginator && (totalRecord$ | async)! >= 0 ? 'mat-table-wrapper-pagination' : '' ]"
  >
    <app-transactions-header
      (triggerDataFromHeader)="getDataFromHeader($event)"
      [listParameters]="listParameters"
      (triggerQuickAdd)="isQuickAdd($event)"
      [transactionModuleId]="moduleEnum.BankDashboard"
      [customId]="customId"
    >
    </app-transactions-header>
    <div>
      <mat-accordion>
        <mat-expansion-panel [expanded]="isBankAccordionExpanded">
          <mat-expansion-panel-header (click)="onPanelHeaderClick()">
            <mat-panel-title>
              <div class="d-flex justify-space-between wp-100">
                <div>
                  <span>Bank Accounts</span>
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-bank-dashboard
            (triggerDataFromBank)="getDataFromBank($event)"
            (triggerIsCustomFlag)="checkIsCustom($event)"
            [triggerHeaderChange]="triggerHeaderChange"
            [triggerTabChange]="triggerTabChange"
            [selectedBankId]="selectedBankId"
          ></app-bank-dashboard>
          <div class="sidenav-table wp-100">
          <div
            class="mat-table-wrapper"
            [ngClass]="{ 'mat-table-wrapper-noData': noDataFound }"
          >
            <table
              mat-table
              [dataSource]="bankTransactions"
              aria-describedby="Bank-Transactions"
              mat-table
              matSort
              (matSortChange)="sorting(sort.active, sort.direction)"
            >
              <ng-container matColumnDef="srNo">
                <th mat-header-cell *matHeaderCellDef fxFlex="15" class="w-15">
                  <mat-checkbox
                    [(ngModel)]="isAllSelected"
                    (change)="selectAll($event)"
                    [disabled]="isCheckBoxDisabled"
                  >
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <div class="d-flex">
                    <mat-checkbox
                      [(ngModel)]="element.isSelected"
                      [disabled]="isCheckBoxDisabled"
                      (change)="onCheckBoxSelected(element, $event)"
                    >
                    </mat-checkbox>
                  </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
              <ng-container matColumnDef="date">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let element">
                  <div class="white-space-nowrap">{{ element.date | date: "dd-LLL-yyyy" }}</div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
      
              <ng-container matColumnDef="refNo">
                <th mat-header-cell *matHeaderCellDef>Ref No</th>
                <td mat-cell *matCellDef="let element">
                  <span class="d-flex" title="{{ element.refNo }}">
                    <a
                      *ngIf="
                        element.id !== undefined &&
                        element.id !== null &&
                        element.id !== '' &&
                        element.id !== commonService.defaultGuidValue
                      "
                      class="link maxw-100 clamp"
                      (click)="redirect(element.id, element.moduleId, element.isPeriodLocked)"
                    >
                      {{ element.refNo }}
                    </a>
                    <span class="clamp"
                      *ngIf="
                        element.id === undefined ||
                        element.id === null ||
                        element.id === '' ||
                        element.id === commonService.defaultGuidValue
                      "
                    >
                      {{ element.refNo }}
                    </span>
                  </span>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
      
              <ng-container matColumnDef="contact">
                <th mat-header-cell *matHeaderCellDef>Contact</th>
                <td mat-cell *matCellDef="let element">
                  <span class="d-flex" title="{{ element.customerSupplierName }}">
                    <a
                      class="link clamp"
                      (click)="
                        redirect(element.accountId, element.accountTypeModuleId, element.isPeriodLocked)
                      "
                    >
                      {{ element.customerSupplierName }}
                    </a>
                  </span>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
      
              <ng-container matColumnDef="reference">
                <th mat-header-cell *matHeaderCellDef>Reference</th>
                <td
                  mat-cell
                  *matCellDef="let element"
                >
                <div class="d-flex">
                  <div class="clamp" title="{{ element.notes }}">{{ element.notes }}</div>
                </div>                  
                </td>
                <td mat-footer-cell *matFooterCellDef>Total</td>
              </ng-container>
      
              <ng-container matColumnDef="receipts">
                <th mat-header-cell *matHeaderCellDef>Receipts</th>
                <td mat-cell *matCellDef="let element">
                  <div class="white-space-nowrap"> £ {{ element.reciepts | numberPipe }}</div>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                  <div class="white-space-nowrap">£ {{ calculateReceiptTotal() | numberPipe}}</div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
      
              <ng-container matColumnDef="payments">
                <th mat-header-cell *matHeaderCellDef>Payments</th>
                <td mat-cell *matCellDef="let element">
                  <div class="white-space-nowrap">£ {{ element.payments | numberPipe }}</div>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                  <div class="white-space-nowrap">£ {{ calculatePaymentTotal() | numberPipe }}</div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
      
              <ng-container matColumnDef="Balance">
                <th mat-header-cell *matHeaderCellDef>Balance</th>
                <td mat-cell *matCellDef="let element">
                  <div class="white-space-nowrap">£ {{ element.balance | numberPipe }}</div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
      
              <ng-container matColumnDef="transactionID">
                <th mat-header-cell *matHeaderCellDef>TransactionID</th>
                <td
                  mat-cell
                  *matCellDef="let element"
                >
                  <div class="d-flex">
                    <div class="clamp" title="{{ element.transactionId }}">
                      {{ element.transactionId }}
                    </div>
                  </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
      
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let element">
                  <span
                    *ngIf="
                      element.id !== undefined &&
                      element.id !== null &&
                      element.id !== '' &&
                      element.id !== commonService.defaultGuidValue
                    "
                  >
                    <span
                      *ngIf="!element.isManual"
                      class="text-danger-300"
                      title="Unexplained"
                      ><mat-icon>question_mark</mat-icon></span
                    >
                    <span
                      *ngIf="element.isManual && !element.isImported"
                      class="user"
                      title="Manual"
                      ><mat-icon>person</mat-icon></span
                    >
                    <span
                      *ngIf="element.isManual && element.isImported"
                      class="sucess"
                      title="Imported"
                      ><mat-icon>done</mat-icon></span
                    >
                  </span>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
      
              <ng-container matColumnDef="explain">
                <th mat-header-cell *matHeaderCellDef class="w-120">Explain</th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <ng-select
                    class="w-120"
                    [ngClass]="((isViewPermission$ | async) || element.isPeriodLocked) ? 'disable-drop' : ''"
                    *ngIf="!element.isCredit && !element.isManual"
                    #receipt
                    (focus)="receipt.open()"
                    (valueChange)="receipt.close()"
                    [disableOptionCentering]="true"
                    panelClass="mat-select-position"
                    [appendTo]="'.sidenav-table'"
                    (change)="receiptPaymentChange($event, element)"
                    [disabled]="(isViewPermission$ | async) || element.isPeriodLocked"
                  >
                    <ng-option *ngFor="let fn of receiptList" [value]="fn">
                      <div title="{{ fn.name }}">{{ fn.name }}</div>
                    </ng-option>
                  </ng-select>
      
                  <ng-select
                    class="w-120"
                    [ngClass]="((isViewPermission$ | async) || element.isPeriodLocked) ? 'disable-drop' : ''"
                    *ngIf="element.isCredit && !element.isManual"
                    #payment
                    (focus)="payment.open()"
                    (valueChange)="payment.close()"
                    [disableOptionCentering]="true"
                    panelClass="mat-select-position"
                    [appendTo]="'.sidenav-table'"
                    (change)="receiptPaymentChange($event, element)"
                    [disabled]="(isViewPermission$ | async) || element.isPeriodLocked"
                  >
                    <ng-option
                      *ngFor="let fn of paymentList"
                      [value]="fn"
                      [disabled]="
                        (!isBankTranferChangePermission &&
                          fn.moduleId === moduleEnum.BankTransfer) ||
                        (!isJournalChangePermission &&
                          fn.moduleId === moduleEnum.Journals)
                      "
                    >
                      <div title="{{ fn.name }}">{{ fn.name }}</div>
                    </ng-option>
                  </ng-select>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
      
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef class="w-120"></th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <div
                    class="grid-actions"
                    *ngIf="
                      element.id !== undefined &&
                      element.id !== null &&
                      element.id !== '' &&
                      element.id !== commonService.defaultGuidValue
                    "
                    [ngClass]="{
                      'show-button': selectedRowIndex === i,
                      'hide-edit-button': !element.isManual
                    }"
                  >
                    <div
                      class="d-flex align-items-center"
                      *ngFor="let item of actions; let permissionsIndex = index"
                    >
                      <span>
                        <button
                          *ngIf="permissionsIndex < moreActionCount"
                          mat-button
                          disableRipple
                          title="{{ item.name }}"
                          (click)="onButtonClick(element, item.actionType)"
                          [disabled]="
                            ((isViewPermission$ | async) &&
                              item.actionType === actionTypeEnum.Delete) ||
                            (element.moduleId === moduleEnum.Journals &&
                              !isJournalChangePermission &&
                              item.actionType === actionTypeEnum.Delete) ||
                            (element.moduleId === moduleEnum.Payment &&
                              !isPaymentChangePermission &&
                              item.actionType === actionTypeEnum.Delete) ||
                            (element.moduleId === moduleEnum.Receipt &&
                              !isRecieptChangePermission &&
                              item.actionType === actionTypeEnum.Delete) ||
                            (element.moduleId === moduleEnum.Donations &&
                              !isDonationChangePermission &&
                              item.actionType === actionTypeEnum.Delete)
                          "
                        >
                          <mat-icon fontSet="material-icons-outlined">{{
                            item.icon
                          }}</mat-icon>
                        </button>
                      </span>
                      <button
                        mat-button
                        class="more-button"
                        (click)="onToggleMatMenu(i)"
                        [matMenuTriggerFor]="menu"
                        (menuClosed)="allowCloseOnClickOut()"
                        disableRipple
                      >
                        <mat-icon *ngIf="permissionsIndex === moreActionCount"
                          >more_vert</mat-icon
                        >
                      </button>
                    </div>
      
                    <mat-menu
                      #menu="matMenu"
                      xPosition="before"
                      class="more-button-menu"
                    >
                      <ng-container
                        *ngFor="let item of actions; let permissionsIndex = index"
                      >
                        <div *ngIf="permissionsIndex > 2">
                          <button
                            mat-menu-item
                            disableRipple
                            title="{{ item.name }}"
                            (click)="onButtonClick(element, item.actionType)"
                          >
                            <mat-icon fontSet="material-icons-outlined">{{
                              item.icon
                            }}</mat-icon>
                            <span>{{ item.name }} </span>
                          </button>
                        </div>
                      </ng-container>
                    </mat-menu>
                  </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                [ngClass]="isRowHighlighted ? 'highlightRow' : ''"
              ></tr>
              <tr mat-footer-row *matFooterRowDef="displayedColumns" [hidden]="!(bankTransactions?.length > 0)"></tr>
            </table>
            <div *ngIf="!(bankTransactions?.length > 0)" class="text-align-center mt-1">
              No records found
            </div>
          </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="isCashAccordionExpanded">
          <mat-expansion-panel-header (opened)="triggerCashInHand()">
            <mat-panel-title>
              <div class="d-flex justify-space-between wp-100">
                <div>
                  <span>Cash in Hand</span>
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="content-body">
            <div class="cash-slide mt-10">
              <mat-card>
                <div class="card-header pb-1">
                  <div class="d-flex justify-space-between align-items-center gap-10">
                    <div>
                      <p class="text-uppercase m-0" title="">
                      {{cashInHandDetails?.name}}
                      </p>
                    </div>
                    <div class="d-flex align-items-center gap-10 mb-5 bank-action-buttons">
                      <div>
                        <button
                          mat-button 
                          disableRipple
                          (click)="export(exportType.PDF, false, moduleEnum.BankDashboardBankAccount)"
                        >
                          <mat-icon title="Export as PDF" fontSet="material-icons-outlined">picture_as_pdf</mat-icon>
                        </button>
                      </div>
                      <div>
                        <button
                          mat-button 
                          disableRipple 
                          (click)="export(exportType.Excel, false, moduleEnum.BankDashboardBankAccount)"
                        >
                          <mat-icon title="Export to Excel">border_all</mat-icon>
                        </button>
                      </div>
                      <div class="card-status text-align-right">
                        <mat-radio-group><mat-radio-button [checked]="true"></mat-radio-button></mat-radio-group>
                      </div>
                    </div>
                  </div>                  
                </div>
                <mat-card-content>
                  <div>                   
                    <div class="d-flex justify-space-between align-items-center">
                      <div class="d-flex gap-10 align-items-center">
                        <mat-icon fontSet="material-icons-outlined">bar_chart</mat-icon>
                        <p class="m-0" title="">Net Balance</p>
                      </div>
                      <div>
                        <p class="ml-1 mb-0 text-align-right text-primary white-space-nowrap">
                          {{cashInHandDetails?.symbol}}{{cashInHandDetails?.balance | numberPipe}}
                        </p>
                      </div>
                    </div>                    
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
            <div class="sidenav-table wp-100">
            <div class="mat-table-wrapper mt-2" [ngClass]="{ 'mat-table-wrapper-noData': cashInHandnoDataFound }">
              <table
                mat-table
                [dataSource]="cashInHandTransactions"
                aria-describedby="cashInHand-Transactions"
                mat-table
                matSort
                (matSortChange)="sorting(sort.active, sort.direction)"
              >
                <ng-container matColumnDef="srNo">
                  <th mat-header-cell *matHeaderCellDef fxFlex="15" class="w-15">
                    <mat-checkbox
                      [(ngModel)]="isAllSelected"
                      (change)="selectAll($event)"
                      [disabled]="isCheckBoxDisabled"
                    >
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <div class="d-flex">
                      <mat-checkbox
                        [(ngModel)]="element.isSelected"
                        [disabled]="isCheckBoxDisabled"
                        (change)="onCheckBoxSelected(element, $event)"
                      >
                      </mat-checkbox>
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="date">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef class="w-110">Date</th>
                  <td mat-cell *matCellDef="let element">
                    <div class="white-space-nowrap">{{ element.date | date: "dd-LLL-yyyy" }}</div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <ng-container matColumnDef="refNo">
                  <th mat-header-cell *matHeaderCellDef>Ref No</th>
                  <td mat-cell *matCellDef="let element">
                    <span class="d-flex" title="{{ element.refNo }}">
                      <a
                        *ngIf="
                          element.id !== undefined &&
                          element.id !== null &&
                          element.id !== '' &&
                          element.id !== commonService.defaultGuidValue
                        "
                        class="link wmx-100 clamp"
                        (click)="redirect(element.id, element.moduleId, element.isPeriodLocked)"
              >
                        {{ element.refNo }}
                      </a>
                      <span class="clamp"
                        *ngIf="
                          element.id === undefined ||
                          element.id === null ||
                          element.id === '' ||
                          element.id === commonService.defaultGuidValue
                        "
                      >
                        {{ element.refNo }}
                      </span>
                    </span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <ng-container matColumnDef="contact">
                  <th mat-header-cell *matHeaderCellDef>Contact</th>
                  <td mat-cell *matCellDef="let element">
                    <span class="d-flex" title="{{ element.customerSupplierName }}">
                      <a
                        class="link wmx-100 clamp"
                        (click)="
                          redirect(element.accountId, element.accountTypeModuleId, element.isPeriodLocked)">
                        {{ element.customerSupplierName }}
                      </a>
                    </span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <ng-container matColumnDef="reference">
                  <th mat-header-cell *matHeaderCellDef>Reference</th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                  >
                  <div class="d-flex">
                    <div class="clamp" title="{{ element.notes }}">
                        {{ element.notes }}
                      </div>
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>Total</td>
                </ng-container>

                <ng-container matColumnDef="receipts">
                  <th mat-header-cell *matHeaderCellDef class="text-align-right">
                    Receipts
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-align-right">
                    <div class="white-space-nowrap">£ {{ element.reciepts | numberPipe }}</div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef class="text-align-right">
                    <div class="white-space-nowrap">£ {{ this.cashInHandDetails?.totalReceipts | numberPipe }}</div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="payments">
                  <th mat-header-cell *matHeaderCellDef class="text-align-right">
                    Payments
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-align-right">
                    <div class="white-space-nowrap">£ {{ element.payments | numberPipe }}</div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef class="text-align-right">
                    <div class="white-space-nowrap">£ {{ this.cashInHandDetails?.totalPayments | numberPipe }}</div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="Balance">
                  <th mat-header-cell *matHeaderCellDef class="text-align-right">
                    Balance
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-align-right">
                    <div class="white-space-nowrap">£ {{ element.balance | numberPipe }}</div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef class="text-align-right">
                    <div class="white-space-nowrap">£ {{ this.cashInHandDetails?.totalBalance | numberPipe }}</div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef class="w-80"></th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <div
                      class="grid-actions justify-content-end"
                      *ngIf="
                        element.id !== undefined &&
                        element.id !== null &&
                        element.id !== '' &&
                        element.id !== commonService.defaultGuidValue
                      "
                      [ngClass]="{
                        'show-button': selectedRowIndex === i,
                        'hide-edit-button': !element.isManual
                      }"
                    >
                      <div
                        class="d-flex align-items-center"
                        *ngFor="let item of cashactions; let permissionsIndex = index"
                      >
                        <span>
                          <button
                            *ngIf="
                              permissionsIndex < moreActionCount &&
                              element.moduleId !== 134
                            "
                            mat-button
                            disableRipple
                            title="{{ item.name }}"
                            (click)="onButtonClick(element, item.actionType)"
                            [ngClass]="{
                              hidden:
                                (item.actionType ===
                                  actionTypeEnum.AllocateReceipt &&
                                  element.moduleId !== moduleEnum.Receipt &&
                                  element.moduleId !== moduleEnum.Payment) ||
                                (item.actionType ===
                                  actionTypeEnum.AllocateReceipt &&
                                  !element.isAdvance) ||
                                (item.name === 'Allocate Receipt' &&
                                  element.moduleId === moduleEnum.Payment) ||
                                (item.name === 'Allocate Payment' &&
                                  element.moduleId === moduleEnum.Receipt)
                            }"
                          >
                            <mat-icon fontSet="material-icons-outlined">{{
                              item.icon
                            }}</mat-icon>
                          </button>
                        </span>
                      </div>
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns1"[ngClass]="isRowHighlighted ? 'highlightRow' : ''"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns1" [hidden]="!(cashInHandTransactions?.length > 0)"></tr>
              </table>
              <div *ngIf="cashInHandnoDataFound" class="text-align-center mt-1">
                No records found
              </div>
            </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      
    </div>
  </div>
  <div
    class="paginator-wrapper"
    *ngIf="totalSelectedRecords <= 0 && (totalRecord$ | async) > 0"
  >
    <app-custom-paginator
      [length]="totalRecord$ | async"
      [listParameters]="listParameters"
      (pageChanged)="pageChanged($event)"
      (pageSizeVal)="pageSizeVal($event)"
      (togglePaginator)="togglePaginator($event)"
      [triggerPaginationChange]="triggerPaginationChange"
    >
    </app-custom-paginator>
  </div>
</div>

<app-card-footer
  #cardFooter
  *ngIf="totalSelectedRecords > 0"
  [totalSelectedRecords]="totalSelectedRecords"
  (deleteClick)="deleteClick()"
  (exportClick)="export($event, false)"
  (printClick)="printClick()"
  (cancelSelectionClick)="cancelSelectionClick()"
  [getModuleId]="moduleId$ | async"
></app-card-footer>
